import Occurrence from '@/services/occurrence'
import Dashboard from '@/services/dashboard'
import Profile from '@/services/profile'
import Tour from '@/services/tour'

const fetchSummary = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Dashboard.getSummary().then((response) => {
      commit('SET_DASHBOARD_SUMMARY', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchCorretor = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Dashboard.fetchCorretor().then((response) => {
      commit('SET_CORRETOR', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchDashboard = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Profile.dashboard().then((response) => {
      commit('SET_DASHBOARD', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchFinishTour = async (context, obj) => {
  return new Promise((resolve, reject) => {
    Tour.dashboardEnd().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchForceRequest = async (context, payload) => {
  return new Promise((resolve, reject) => {
    Dashboard.fetchForceRequest(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const exportCnabFile = async (context, id) => {
  return new Promise((resolve, reject) => {
    Dashboard.exportCnabFile(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error.response.data)
    })
  })
}

const exportExcelAssigmentRequest = async (context, id) => {
  return new Promise((resolve, reject) => {
    Dashboard.exportExcelAssigmentRequest(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error.response.data)
    })
  })
}

const generateTermoCessao = async (context, id) => {
  return new Promise((resolve, reject) => {
    Dashboard.generateTermoCessao(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error.response.data)
    })
  })
}

const exportCnabFileFromMultipleARs = async (context, ids) => {
  return new Promise((resolve, reject) => {
    Dashboard.exportCnabFileFromMultipleARs(ids).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error.response.data)
    })
  })
}

const getNestedOcurrenceByOcurrenceId = async (context, id) => {
  return new Promise((resolve, reject) => {
    Occurrence.nestedOccurrenceById(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error.response.data)
    })
  })
}

const loadSummaryDatatable = async ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    Dashboard.loadSummaryDatatable(params).then((response) => {
      commit('SET_SUMMARY_DATATABLE', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const updateValuesSumarize = async ({ commit }, payload) => {
  commit('SET_SUMMARY_DATATABLE', payload)
  commit('SET_PARAMS_QUERY_SUMMARY_DATATABLE')
}

export default {
  fetchSummary,
  fetchDashboard,
  fetchCorretor,
  fetchFinishTour,
  fetchForceRequest,
  loadSummaryDatatable,
  exportCnabFile,
  generateTermoCessao,
  exportCnabFileFromMultipleARs,
  updateValuesSumarize,
  getNestedOcurrenceByOcurrenceId,
  exportExcelAssigmentRequest
}



// WEBPACK FOOTER //
// ./src/features/dashboard/store/actions.js